
import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,
    Container,
    Row,
    Col,
    FormGroup,
    Label,
    Input
} from 'reactstrap';

import RGL, { WidthProvider } from "react-grid-layout";
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

import Isvg from 'react-inlinesvg';
import moveIcon from '../../assets/svg/move.svg';
import moreIcon from '../../assets/svg/more.svg';
import infoIcon from "../../assets/svg/link-new-tab.svg";


import moment, { lang } from 'moment';
import DateNavigation from './dateNavigation';
import CalendarEventComponent from './calendarEventComponent';
import CustomCalendar from './customCalendar';
import CustomFilterCalendar from './customFilterCalendar';
import Page from '../../containers/page';
import { API_ENDPOINT } from '../../constants';
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import { v4 as uuidv4 } from 'uuid';
import UpdateEventModal from './updateEventModal';
import ErrorModal from '../../components/errorModal';
import ScheduleEventModal from './scheduleEventModal';
import ScheduleSlot from './scheduleEventHelper/scheduleSlot';
import OccupancyCalendar from './occupancyCalendar';
import CustomFilterStatistics from './statistics/customFilterStatistics';
import PieGraph from './graphs/pieGraph';
import BarGraph from './graphs/barGraph';
import { GRAPH_COLORS } from './graphs/colorHelper';
import { getHumanReadable } from './helper';

import html2canvas from 'html2canvas';



function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}


class Statistics extends React.Component {

    constructor(props) {
        super(props);
        this.wrapperRef = React.createRef();

        const tsNow = Math.floor(new Date().getTime() / 1000);
        this.state = {
            filter: {
                range: {
                    start: this.props.getStringDateTs(tsNow, 'MM/DD/YYYY'),
                    end: this.props.getStringDateTs(tsNow, 'MM/DD/YYYY')
                },
                groups: [],
                clinics: [],
                clinicians: []
            },
            activeTab: 1,
            statisticsView: 'day',
            statisticsViewOptions: [
                { value: 'day', label: 'Day'.translate(this.props.lang) },
                { value: 'week', label: 'Week'.translate(this.props.lang) },
                { value: 'month', label: 'Month'.translate(this.props.lang) },
                { value: 'year', label: 'Year'.translate(this.props.lang) }
            ]

        }
    }

    setInitialData = () => {
    }




    componentDidMount() {
        this.setInitialData();


    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.selectedGroup !== this.props.selectedGroup || prevProps.selectedClinic !== this.props.selectedClinic) {
            this.resetPage();
        }

    }
    resetPage = () => {
        const pathname = this.props[0].location.pathname;
        const refreshPathname = '/refresh/page';
        const stateObj = {
            reditectTo: pathname
        }
        if (pathname) {
            this.props[0].history.push(refreshPathname, stateObj);
        }
    }
    componentWillUnmount() {


    }

    fetchItems = () => {
        const filter = this.state.filter;
        if (!filter) return;

        const groups = filter?.groups ?? [];
        const clinics = filter?.clinics ?? [];
        const clinicians = filter?.clinicians ?? [];
        const range = filter?.range ?? {};
        const activeTab = this.state.activeTab ?? 1;
        const type = activeTab === 1 ? 'calendar' : activeTab === 2 ? 'dropin' : null;

        let data = {
            groups,
            clinics,
            clinicians,
            range,
            type,
            groupId: this.props.selectedGroup,
            clinicId: this.props.selectedClinic,
            lang: this.props.lang,
            statisticsView: this.state.statisticsView,
            dateFormat: this.props.dateFormat,
        }

        this.setState({
            loading: true,
            statisticsData: null,
            summary: null,
            questionnairesStatistics: null,
            doctorsStatistics: null
        }, () => {
            let fetchKey = uuidv4();
            this.fetchKey = fetchKey;
            data.fetchKey = fetchKey;
            fetch(API_ENDPOINT + `/data/calendar/statistics/fetch`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                this.resetGraphImage();
                if (result?.statistics && this.fetchKey === result?.fetchKey) {
                    let setObj = {
                        loading: false
                    }
                    if (activeTab === 1) {
                        setObj = {
                            ...setObj,
                            statisticsData: result.statistics?.statisticsData,
                            summary: result?.statistics?.summary,
                            questionnairesStatistics: result?.statistics?.questionnaires,
                            doctorsStatistics: result?.statistics?.doctors,
                            templatesStatistics: result?.statistics?.templates,
                        }
                    } else if (activeTab === 2) {
                        setObj = {
                            ...setObj,
                            statisticsData: result.statistics?.statisticsData,
                            summary: result?.statistics?.summary,
                            questionnairesStatistics: result?.statistics?.questionnaires,
                            doctorsStatistics: result?.statistics?.doctors
                        }
                    }
                    this.setState(setObj)
                } else {
                    this.setState({ loading: false })
                }
            }).catch(err => {
                console.log(err);
                this.setState({ loading: false })
            })
        })

    }
    resetGraphImage = () => {
        this.setState({ resetGraphImage: new Date().getTime() })
    }

    setActiveTab = (activeTab) => {
        this.setState({ activeTab }, () => {
            this.fetchItems();
        })
    }

    generateSummaryTooltip = (summary) => {
        if (!summary) return null;
        let scheduledTooltip = [], waitingTooltip = [], cancelledTooltip = [];
        let status = summary?.cases?.status ?? null;
        for (var key in status) {
            let statusLabel = getHumanReadable(key, this.props.lang);
            if (['allowed', 'requested-new-appointment', 'waiting-for-approval', 'waiting-for-payment-before-submission']?.indexOf(key) !== -1) {
                waitingTooltip.push({
                    label: statusLabel,
                    value: status[key]
                })
            } else if (['revisit-scheduled', 'scheduled', 'visit-rescheduled']?.indexOf(key) !== -1) {
                scheduledTooltip.push({
                    label: statusLabel,
                    value: status[key]
                })
            } else if (['canceled-by-clinic', 'disallowed', 'patient-rejected']?.indexOf(key) !== -1) {
                cancelledTooltip.push({
                    label: statusLabel,
                    value: status[key]
                })
            }
        }
        let response = {
            scheduledTooltip: scheduledTooltip?.length ? scheduledTooltip : [],
            waitingTooltip: waitingTooltip?.length ? waitingTooltip : [],
            cancelledTooltip: cancelledTooltip?.length ? cancelledTooltip : []
        };
        return response;

    }
    convertToBase64 = async (ref) => {
        if (ref?.current) {
            try {
                const canvas = await html2canvas(ref.current);
                const base64image = canvas.toDataURL('image/png');
                return base64image;
            } catch (error) {
                console.error("Greška prilikom konvertovanja:", error);
            }
        } else {
            console.warn("Ref nije definisan");
        }
    };
    exportPdf = (data) => {
        if (!data || !data?.graphs) return;

        this.setState({ loadingExport: true }, () => {

            fetch(API_ENDPOINT + `/data/calendar/statistics/pdf`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                if (result?.pdf) {
                    setTimeout(() => {
                        let path = result.pdf;
                        let name = result?.pdfName ?? 'occupancy.pdf';
                        let pdfUrl = API_ENDPOINT + path;
                        var link = document.createElement("a");
                        link.download = name ? name : 'test';
                        link.target = "_blank";

                        link.href = pdfUrl;
                        document.body.appendChild(link);
                        link.click();

                        this.setState({ loadingExport: false, exportModal: false })
                    }, 1000);
                } else {
                    this.setState({ loadingExport: false, exportModal: false })
                }

            }).catch(err => {
                console.log(err);
                this.setState({ loadingExport: false })
            })
        })
    }

    prepareExportPdf = () => {

        const graphs = {
            doctorsGraph: {
                image: this.doctorsGraph?.(),
                datasets: this.doctorsGraphDatasets?.()
            },
            questionnairesGraph: {
                image: this.questionnairesGraph?.(),
                datasets: this.questionnairesDatasets?.()
            },
            statisticsDataGraph: {
                image: this.statisticsDataGraph?.(),
            },
            statisticsTemplatesDataGraph: {
                image: this.statisticsTemplatesDataGraph?.(),
            },
            doctorsTemplatesGraph: {
                image: this.doctorsTemplatesGraph?.(),
                datasets: this.doctorsTemplatesGraphDatasets?.()
            },
            availabilityTemplatesGraph: {
                image: this.availabilityTemplatesGraph?.(),
                datasets: this.availabilityTemplatesGraphDatasets?.()
            }
        };
        const filter = this.state.filter;

        const groups = filter?.groups ?? [];
        const clinics = filter?.clinics ?? [];
        const clinicians = filter?.clinicians ?? [];
        const range = filter?.range ?? {};
        const activeTab = this.state.activeTab ?? 1;
        const type = activeTab === 1 ? 'calendar' : activeTab === 2 ? 'dropin' : null;

        const summary = this.state.summary ?? null;
        // const questionnairesStatistics = this.state.questionnairesStatistics ?? null;
        // const doctorsStatistics = this.state.doctorsStatistics ?? null;
        const templatesStatistics = this.state.templatesStatistics ?? null;
        // const statisticsData = this.state.statisticsData ?? null;

        let data = {
            groups,
            clinics,
            clinicians,
            range,
            type,
            groupId: this.props.selectedGroup,
            clinicId: this.props.selectedClinic,
            lang: this.props.lang,
            statisticsView: this.state.statisticsView,
            dateFormat: this.props.dateFormat,
            graphs,
            summary,
            templatesStatistics
        }

        this.exportPdf(data);

    }
    render() {
        if (typeof window === 'undefined') {
            return;
        }
        // if (window.innerWidth < 768) {
        //     return (
        //         <div className={this.props.autoHideSidebar ? "dashboard dashboard-auto-hide" : "dashboard"}>
        //             <p style={{ textAlign: 'center', fontWeight: 600, marginTop: 50 }}>
        //                 {"Please use a desktop device to access this page.".translate(this.props.lang)}
        //             </p>
        //         </div>
        //     )
        // }
        const activeTab = this.state.activeTab ?? 1;

        const summary = this.state.summary ?? null;

        const questionnairesStatistics = this.state.questionnairesStatistics ?? null;

        const doctorsStatistics = this.state.doctorsStatistics ?? null;

        const templatesStatistics = this.state.templatesStatistics ?? null;

        const statisticsData = this.state.statisticsData ?? null;

        const tooltipData = this.generateSummaryTooltip(summary);

        return (
            <div className={this.props.autoHideSidebar ? "dashboard dashboard-auto-hide" : "dashboard"}>
                <Container fluid>
                    <Row>
                        <Col lg='12'>
                            <div className='panel'>
                                <div className="component-header-wrap">
                                    <h5 className="component-header">
                                        {this.props.linksMeta && this.props.linksMeta[this.props[0].location.pathname] ? this.props.linksMeta[this.props[0].location.pathname][this.props.lang] : ''}
                                    </h5>
                                    <div className="component-header-actions">
                                        <Button
                                            color="primary"
                                            disabled={!summary}
                                            onClick={() => {
                                                this.prepareExportPdf();
                                                // this.setState({ exportModal: !this.state.exportModal })
                                            }}>
                                            {'Save as PDF'.translate(this.props.lang)}
                                        </Button>
                                        {/* <Button
                                            color="primary"
                                            disabled={!this.state.availabilityData}
                                            onClick={() => {
                                                // this.setState({ exportModal: !this.state.exportModal })
                                            }}>
                                            {'Save'.translate(this.props.lang)}
                                        </Button> */}
                                    </div>

                                </div>

                                <div className='multi-calendar-wrap occupancy-calendar-wrap'>

                                    {
                                        this.state.loading || this.state.loadingExport ?
                                            <div className="export-loader-wrap">
                                                <div className="loader-wrap">
                                                    <Player
                                                        autoplay={true}
                                                        loop={true}
                                                        renderer={'svg'}
                                                        src="/lf30_editor_l5cxzdyf.json"
                                                        style={{ height: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px", width: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px" }}
                                                    ></Player>

                                                </div>
                                            </div>
                                            :
                                            null
                                    }

                                </div>
                                <div className="tabs-buttons-wrap" style={{ marginBottom: 30 }}>
                                    <Button
                                        className={activeTab === 1 ? "tab-button acitve-tab-button" : "tab-button"}
                                        onClick={() => {
                                            this.setActiveTab(1);
                                        }}
                                    >{"Calendar".translate(this.props.lang)}</Button>

                                    <Button
                                        className={activeTab == 2 ? "tab-button acitve-tab-button" : "tab-button"}
                                        onClick={() => {
                                            this.setActiveTab(2);
                                        }}
                                    >{"Drop in".translate(this.props.lang)}</Button>

                                </div>
                                <div>
                                    <CustomFilterStatistics
                                        {...this.props}
                                        onChange={(data) => {
                                            // console.log('data', data)
                                            let filter = {
                                                groups: [...data.groups],
                                                clinics: [...data.clinics],
                                                clinicians: [...data.clinicians],
                                                range: { ...data.range }
                                            }
                                            let changesExists = false;
                                            if (JSON.stringify(filter) !== JSON.stringify(this.state.filter)) {
                                                changesExists = true;
                                            } else if (filter.groups.length !== this.state.filter.groups.length) {
                                                changesExists = true;
                                            } else if (filter.clinics.length !== this.state.filter.clinics.length) {
                                                changesExists = true;
                                            } else if (filter.clinicians.length !== this.state.filter.clinicians.length) {
                                                changesExists = true;
                                            }

                                            if (changesExists) {
                                                this.setState({
                                                    filter
                                                }, () => {
                                                    this.fetchItems();
                                                })
                                            }

                                        }}
                                    />
                                </div>

                                <div className='statistics-calendar-wrap'>

                                    {
                                        activeTab === 1 && summary ?
                                            <div>
                                                <div className='calendar-statistics-wrap'>
                                                    <table>
                                                        <tr>
                                                            <td>{'Number of cases'.translate(this.props.lang)}:</td>
                                                            <td>
                                                                <div className='element-value'> {summary?.cases?.total}</div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>{'Scheduled'.translate(this.props.lang)}:</td>
                                                            <td>
                                                                <div className='element-with-tooltip'>
                                                                    <div className='element-value'> {summary?.cases?.scheduled}</div>
                                                                    {
                                                                        tooltipData?.scheduledTooltip?.length ?
                                                                            <div className='table-element-tooltip-wrap'>
                                                                                <Isvg src={infoIcon} />
                                                                                <div className="table-element-tooltip">
                                                                                    {
                                                                                        tooltipData?.scheduledTooltip?.map((item, index) => {
                                                                                            return (
                                                                                                <>
                                                                                                    {index > 0 ? <br /> : null}
                                                                                                    {item.label} : {item.value}
                                                                                                </>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                            :
                                                                            null
                                                                    }
                                                                </div>

                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>{'Waiting for scheduling'.translate(this.props.lang)}:</td>
                                                            <td>
                                                                <div className='element-with-tooltip'>
                                                                    <div className='element-value'> {summary?.cases?.waitingForScheduling}</div>
                                                                    {
                                                                        tooltipData?.waitingTooltip?.length ?
                                                                            <div className='table-element-tooltip-wrap'>
                                                                                <Isvg src={infoIcon} />
                                                                                <div className="table-element-tooltip">
                                                                                    {
                                                                                        tooltipData?.waitingTooltip?.map((item, index) => {
                                                                                            return (
                                                                                                <>
                                                                                                    {index > 0 ? <br /> : null}
                                                                                                    {item.label} : {item.value}
                                                                                                </>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                            :
                                                                            null
                                                                    }
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>{'Cancelled'.translate(this.props.lang)}:</td>
                                                            <td>
                                                                <div className='element-with-tooltip'>
                                                                    <div className='element-value'> {summary?.cases?.cancelled}</div>
                                                                    {
                                                                        tooltipData?.cancelledTooltip?.length ?
                                                                            <div className='table-element-tooltip-wrap'>
                                                                                <Isvg src={infoIcon} />
                                                                                <div className="table-element-tooltip">
                                                                                    {
                                                                                        tooltipData?.cancelledTooltip?.map((item, index) => {
                                                                                            return (
                                                                                                <>
                                                                                                    {index > 0 ? <br /> : null}
                                                                                                    {item.label} : {item.value}
                                                                                                </>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                            :
                                                                            null
                                                                    }
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>{'Closed'.translate(this.props.lang)}:</td>
                                                            <td> <div className='element-value'> {summary?.cases?.closed}</div></td>
                                                        </tr>

                                                    </table>
                                                    {
                                                        doctorsStatistics ?
                                                            <div className='drop-in-statistics-pie-graph-wrap'>

                                                                <PieGraph
                                                                    key={'pie-graph-1'}
                                                                    getStringDateTs={this.props.getStringDateTs}
                                                                    lang={this.props.lang}
                                                                    data={doctorsStatistics}
                                                                    resetGraphImage={this.state.resetGraphImage}
                                                                    getGraphImage={(img) => {
                                                                        this.doctorsGraph = img;
                                                                    }}
                                                                    getDatasets={(datasets) => {
                                                                        this.doctorsGraphDatasets = datasets;
                                                                    }}
                                                                />
                                                                <h6>{'Caregivers'.translate(this.props.lang)}</h6>

                                                            </div>
                                                            :
                                                            null
                                                    }

                                                    {
                                                        questionnairesStatistics ?
                                                            <div className='drop-in-statistics-pie-graph-wrap'>

                                                                <PieGraph
                                                                    key={'pie-graph-2'}
                                                                    getStringDateTs={this.props.getStringDateTs}
                                                                    lang={this.props.lang}
                                                                    data={questionnairesStatistics}
                                                                    resetGraphImage={this.state.resetGraphImage}
                                                                    getGraphImage={(img) => {
                                                                        this.questionnairesGraph = img;
                                                                    }}
                                                                    getDatasets={(datasets) => {
                                                                        this.questionnairesDatasets = datasets;
                                                                    }}
                                                                />
                                                                <h6>{'Visit reasons'.translate(this.props.lang)}</h6>

                                                            </div>
                                                            :
                                                            null
                                                    }
                                                </div>
                                                {
                                                    statisticsData ?
                                                        <div className='drop-in-statistics-bar-graph-wrap'>
                                                            <div className='drop-in-statistics-bar-graph-header'>
                                                                <Input
                                                                    type='select'
                                                                    value={this.state.statisticsView}
                                                                    onChange={(e) => {
                                                                        let value = e.target.value;
                                                                        this.setState({ statisticsView: value }, () => {
                                                                            this.fetchItems();
                                                                        })
                                                                    }}
                                                                >
                                                                    {
                                                                        this.state.statisticsViewOptions.map((item, index) => {
                                                                            return (
                                                                                <option key={index} value={item.value}>{item.label}</option>
                                                                            )
                                                                        })
                                                                    }
                                                                </Input>
                                                            </div>
                                                            <div className='drop-in-statistics-bar-graph'>
                                                                <BarGraph
                                                                    key={'bar-graph-1'}
                                                                    getStringDateTs={this.props.getStringDateTs}
                                                                    lang={this.props.lang}
                                                                    data={statisticsData}
                                                                    resetGraphImage={this.state.resetGraphImage}
                                                                    getGraphImage={(img) => {
                                                                        this.statisticsDataGraph = img;
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                                }
                                                {
                                                    templatesStatistics?.total ?
                                                        <div className='calendar-statistics-wrap' style={{ marginTop: 100 }}>
                                                            <table>
                                                                <tr>
                                                                    <td>
                                                                        <div className='element-with-tooltip' style={{ gap: 4 }}>
                                                                            <div className='element-value' style={{ width: 'unset' }}>{'Number of event templates'.translate(this.props.lang)}</div>
                                                                            <div className='table-element-tooltip-wrap'>
                                                                                <Isvg src={infoIcon} />
                                                                                <div className="table-element-tooltip">
                                                                                    {'Number of active event templates available for booking revisits in the calendar.'.translate(this.props.lang)}
                                                                                </div>
                                                                            </div>
                                                                            :
                                                                        </div>

                                                                    </td>
                                                                    <td>
                                                                        {templatesStatistics?.total}
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                            {
                                                                templatesStatistics?.doctors ?
                                                                    <div className='drop-in-statistics-pie-graph-wrap'>

                                                                        <PieGraph
                                                                            key={'pie-graph-3'}
                                                                            getStringDateTs={this.props.getStringDateTs}
                                                                            lang={this.props.lang}
                                                                            data={templatesStatistics.doctors}
                                                                            resetGraphImage={this.state.resetGraphImage}
                                                                            getGraphImage={(img) => {
                                                                                this.doctorsTemplatesGraph = img;
                                                                            }}
                                                                            getDatasets={(datasets) => {
                                                                                this.doctorsTemplatesGraphDatasets = datasets;
                                                                            }}
                                                                        />
                                                                        <div className='element-tooltip-wrapper'>
                                                                            <h6>{'Caregivers'.translate(this.props.lang)}</h6>
                                                                            {/* <div className='element-tooltip-wrap'>
                                                                                <Isvg src={infoIcon} />
                                                                                <div className="table-element-tooltip">
                                                                                    {'test'.translate(this.props.lang)}
                                                                                </div>
                                                                            </div> */}
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    null
                                                            }

                                                            {
                                                                templatesStatistics?.availabilityTemplates ?
                                                                    <div className='drop-in-statistics-pie-graph-wrap'>

                                                                        <PieGraph
                                                                            key={'pie-graph-4'}
                                                                            getStringDateTs={this.props.getStringDateTs}
                                                                            lang={this.props.lang}
                                                                            data={templatesStatistics.availabilityTemplates}
                                                                            resetGraphImage={this.state.resetGraphImage}
                                                                            getGraphImage={(img) => {
                                                                                this.availabilityTemplatesGraph = img;
                                                                            }}
                                                                            getDatasets={(datasets) => {
                                                                                this.availabilityTemplatesGraphDatasets = datasets;
                                                                            }}
                                                                        />
                                                                        <div className='element-tooltip-wrapper'>
                                                                            <h6>{'Booking templates'.translate(this.props.lang)}</h6>
                                                                            {/* <div className='element-tooltip-wrap'>
                                                                                <Isvg src={infoIcon} />
                                                                                <div className="table-element-tooltip">
                                                                                    {'test'.translate(this.props.lang)}
                                                                                </div>
                                                                            </div> */}
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                        :
                                                        null
                                                }
                                                {
                                                    statisticsData?.datasetsTemplates?.length ?
                                                        <div className='drop-in-statistics-bar-graph-wrap'>
                                                            <div className='drop-in-statistics-bar-graph-header'>
                                                                <Input
                                                                    type='select'
                                                                    value={this.state.statisticsView}
                                                                    onChange={(e) => {
                                                                        let value = e.target.value;
                                                                        this.setState({ statisticsView: value }, () => {
                                                                            this.fetchItems();
                                                                        })
                                                                    }}
                                                                >
                                                                    {
                                                                        this.state.statisticsViewOptions.map((item, index) => {
                                                                            return (
                                                                                <option key={index} value={item.value}>{item.label}</option>
                                                                            )
                                                                        })
                                                                    }
                                                                </Input>
                                                            </div>
                                                            <div className='drop-in-statistics-bar-graph'>
                                                                <BarGraph
                                                                    key={'bar-graph-2'}
                                                                    getStringDateTs={this.props.getStringDateTs}
                                                                    lang={this.props.lang}
                                                                    data={{
                                                                        ...statisticsData,
                                                                        datasets: statisticsData?.datasetsTemplates
                                                                    }}
                                                                    resetGraphImage={this.state.resetGraphImage}
                                                                    getGraphImage={(img) => {
                                                                        this.statisticsTemplatesDataGraph = img;
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                                }


                                            </div>
                                            :
                                            null
                                    }

                                    {
                                        activeTab === 2 && summary ?
                                            <div>
                                                <div className='drop-in-statistics-wrap'>
                                                    <table>
                                                        <tr>
                                                            <td>{'Number of drop-ins'.translate(this.props.lang)}:</td>
                                                            <td>{summary?.total}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{'Waiting'.translate(this.props.lang)}:</td>
                                                            <td>{summary?.waiting}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{'In progress'.translate(this.props.lang)}:</td>
                                                            <td>{summary?.inProgress}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{'Closed'.translate(this.props.lang)}:</td>
                                                            <td>{summary?.closed}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                {/* {'Average duration'.translate(this.props.lang)}: */}
                                                                <div className='element-with-tooltip' style={{ gap: 4 }}>
                                                                    <div className='element-value' style={{ width: 'unset' }}>{'Average duration'.translate(this.props.lang)}</div>
                                                                    <div className='table-element-tooltip-wrap'>
                                                                        <Isvg src={infoIcon} />
                                                                        <div className="table-element-tooltip">
                                                                            {'The time a case has had the status "ongoing"'.translate(this.props.lang)}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>{summary?.avgDuration}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                {/* {'Average waiting time'.translate(this.props.lang)}: */}
                                                                <div className='element-with-tooltip' style={{ gap: 4 }}>
                                                                    <div className='element-value' style={{ width: 'unset' }}>{'Average waiting time'.translate(this.props.lang)}</div>
                                                                    <div className='table-element-tooltip-wrap'>
                                                                        <Isvg src={infoIcon} />
                                                                        <div className="table-element-tooltip">
                                                                            {'The time a case has had the status "waiting"'.translate(this.props.lang)}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>

                                                            <td>{summary?.avgWaitingTime}</td>
                                                        </tr>
                                                    </table>

                                                    {
                                                        doctorsStatistics ?
                                                            <div className='drop-in-statistics-pie-graph-wrap'>

                                                                <PieGraph
                                                                    key={'pie-graph-5'}
                                                                    getStringDateTs={this.props.getStringDateTs}
                                                                    lang={this.props.lang}
                                                                    data={doctorsStatistics}
                                                                    resetGraphImage={this.state.resetGraphImage}
                                                                    getGraphImage={(img) => {
                                                                        this.doctorsGraph = img;
                                                                    }}
                                                                    getDatasets={(datasets) => {
                                                                        this.doctorsGraphDatasets = datasets;
                                                                    }}
                                                                />
                                                                <h6>{'Caregivers'.translate(this.props.lang)}</h6>

                                                            </div>
                                                            :
                                                            null
                                                    }

                                                    {
                                                        questionnairesStatistics ?
                                                            <div className='drop-in-statistics-pie-graph-wrap'>

                                                                <PieGraph
                                                                    key={'pie-graph-6'}
                                                                    getStringDateTs={this.props.getStringDateTs}
                                                                    lang={this.props.lang}
                                                                    data={questionnairesStatistics}
                                                                    resetGraphImage={this.state.resetGraphImage}
                                                                    getGraphImage={(img) => {
                                                                        this.questionnairesGraph = img;
                                                                    }}
                                                                    getDatasets={(datasets) => {
                                                                        this.questionnairesDatasets = datasets;
                                                                    }}
                                                                />
                                                                <h6>{'Visit reasons'.translate(this.props.lang)}</h6>

                                                            </div>
                                                            :
                                                            null
                                                    }

                                                </div>
                                                {
                                                    statisticsData ?
                                                        <div className='drop-in-statistics-bar-graph-wrap'>
                                                            <div className='drop-in-statistics-bar-graph-header'>
                                                                <Input
                                                                    type='select'
                                                                    value={this.state.statisticsView}
                                                                    onChange={(e) => {
                                                                        let value = e.target.value;
                                                                        this.setState({ statisticsView: value }, () => {
                                                                            this.fetchItems();
                                                                        })
                                                                    }}
                                                                >
                                                                    {
                                                                        this.state.statisticsViewOptions.map((item, index) => {
                                                                            return (
                                                                                <option key={index} value={item.value}>{item.label}</option>
                                                                            )
                                                                        })
                                                                    }
                                                                </Input>
                                                            </div>
                                                            <div className='drop-in-statistics-bar-graph'>
                                                                <BarGraph
                                                                    key={'bar-graph-3'}
                                                                    getStringDateTs={this.props.getStringDateTs}
                                                                    lang={this.props.lang}
                                                                    data={statisticsData}
                                                                    resetGraphImage={this.state.resetGraphImage}
                                                                    getGraphImage={(img) => {
                                                                        this.statisticsDataGraph = img;
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                                }
                                            </div>
                                            :
                                            null
                                    }
                                </div>

                            </div>

                        </Col>
                    </Row>
                </Container>
                {
                    this.state.exportModal ?
                        <Modal
                            isOpen={this.state.exportModal}
                            toggle={() => this.setState({ exportModal: null })}
                            className='custom-calendar-event-preview-modal'
                            centered
                        >
                            <ModalBody>

                            </ModalBody>
                            <ModalFooter className='modal-footer-buttons-wrap' style={{ justifyContent: 'center' }}>
                                {/* <Button
                                    color="primary"
                                    style={{ minWidth: 100 }}
                                    disabled={this.state.loadingExport}
                                    onClick={() => {
                                        this.exportData('excel');
                                    }}
                                >
                                    {'Excel'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    color="primary"
                                    style={{ minWidth: 100 }}
                                    disabled={this.state.loadingExport}
                                    onClick={() => {
                                        this.exportData('pdf');
                                    }}
                                >
                                    {'PDF'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    color="primary"
                                    disabled={this.state.loadingExport}
                                    style={{ minWidth: 100 }}
                                    onClick={() => this.setState({ exportModal: null })}
                                >
                                    {'Close'.translate(this.props.lang)}
                                </Button> */}
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }


                {
                    this.state.error ?
                        <ErrorModal
                            lang={this.props.lang}
                            isOpen={this.state.error}
                            toggle={() => this.setState({ error: null })}
                            closeButtonText={'Cancel'.translate(this.props.lang)}
                        >
                            {this.state.error}
                        </ErrorModal>
                        :
                        null
                }

            </div>


        )
    }
}

export default Page(Statistics);